import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRequisitionWorkflowFields {
		id?: any;
		requisitionId?: any;
		workflowId?: any;
		datestamp?: any;
		userId?: any;
		comments?: any;
}

export class RequisitionWorkflowFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public requisitionId: IEntityModelField = { name: "requisitionId", displayName: "Requisition Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public workflowId: IEntityModelField = { name: "workflowId", displayName: "Workflow Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric" };
	public userId: IEntityModelField = { name: "userId", displayName: "User Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public comments: IEntityModelField = { name: "comments", displayName: "Comments", fieldType: FieldType.String, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.requisitionId);
		this.push(this.workflowId);
		this.push(this.datestamp);
		this.push(this.userId);
		this.push(this.comments);
	}
}

export class RequisitionWorkflowDTO implements IEntityModel {
	protected requisitionWorkflowName: string = "RequisitionWorkflowModel";
	protected requisitionWorkflowKeyField: string = "id";
	protected requisitionWorkflowDisplayName: string = "Requisition Workflow|Requisition Workflows";
	protected requisitionWorkflowFields = new RequisitionWorkflowFields();
	public get name(): string { return this.requisitionWorkflowName };
	public get keyField(): string { return this.requisitionWorkflowKeyField };
	public get displayName(): string { return this.requisitionWorkflowDisplayName };
	public get fields(): RequisitionWorkflowFields { return this.requisitionWorkflowFields };

	constructor() {};
}
